import { Injectable, inject } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  protected loadingCtrl = inject(LoadingController);
  private loading: HTMLIonLoadingElement | null = null;

  async show(message?: string) {
    if (!this.loading) {
      this.loading = await this.loadingCtrl.create({
        message: message || undefined,
        spinner: 'crescent'
      });
      await this.loading.present();
    }
  }

  async hide() {
    if (this.loading) {
      await this.loading.dismiss();
      this.loading = null;
    }
  }
}
